// src/main.js 入口
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);
Vue.config.productionTip = false;

// API 错误已由请求拦截器统一提示，避免开发服务器再弹出整屏错误遮罩。
window.addEventListener('unhandledrejection', event => {
  if (event.reason && event.reason.isHandledApiError) {
    event.preventDefault();
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
